import { GridColumnVisibilityModel } from "@mui/x-data-grid";
import { create } from "zustand";

export interface State {
  comment: GridColumnVisibilityModel;
}

export interface Actions {
  updateColumnVisibility: (columnName: string, isVisible: boolean) => void;
  reset: () => void;
}

export type Store = State & Actions;

const initialState = {
  comment: {
    commentLink: true,
    entityName: true,
    entityType: true,
    universe: true,
    authorName: true,
    isAnnualMeetingNote: true,
    esg: true,
    dei: true,
    netZero: true,
    quarterlyMonitoring: true,
    quarter: true,
    annualMonitoring: true,
    sec: true,
    annualMeetingCompliance: true,
    govComplete: true,
    oddComment: true,
    aiSummaryInternal: true,
    aiSummaryExternal: true,
    restrictedText: true,
    fundName: true,
    performanceSection: true,
    fundraisingSection: true,
    legalSection: true,
    createdByPersonName: true,
    // Created Date
    creTimest: true,
    updatedByPersonName: true,
    // Last Modified Date
    modTimest: true,

    id: false,
    entityLegacyId: false,
    entityId: false,
    scheduledById: false,
    createdById: false,
    updatedById: false,
  },
};

export const useCommentColumnVisibilityStore = create<Store>((set) => ({
  ...initialState,
  updateColumnVisibility: (columnName: string, isVisible: boolean) => {
    set((state) => ({
      comment: {
        ...state.comment,
        [columnName]: isVisible,
      },
    }));
  },
  reset: () => set(initialState),
}));
